import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getBankAccountsDirectory } from '../bankAccountsDirectoryEndpoints'
import { bankAccountsDirectoryKeys } from '../bankAccountsDirectoryQueryKeys'
import type { GetBankAccountsDirectoryParams } from '../../types/bankAccountsDirectoryTypes'

const DEFAULT_PAGE = 1
const DEFAULT_LIMIT = 10

export function useBankAccountsDirectoryListQuery(
  filters: MaybeRefOrGetter<Partial<GetBankAccountsDirectoryParams>>,
) {
  return useQuery({
    queryKey: () => bankAccountsDirectoryKeys.list(toValue(filters)),
    queryFn: () =>
      getBankAccountsDirectory({
        page: DEFAULT_PAGE,
        limit: DEFAULT_LIMIT,
        ...toValue(filters),
      }),
    placeholderData: keepPreviousData,
  })
}
